import React, { useState } from "react";
import CalendarDays from "lucide-react/dist/esm/icons/calendar-days";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./UI";

/** DD/MM/YYYY → Date (local) or null. */
export function parseUkDate(s) {
  const m = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/.exec(s || "");
  if (m) {
    const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    return d.getDate() === Number(m[1]) && d.getMonth() === Number(m[2]) - 1 ? d : null;
  }
  const iso = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(s || "");
  if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  return null;
}

export function formatUkDate(d) {
  if (!d) return "";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

/** LT-39 — typed DD/MM/YYYY with a calendar picker beside it. Value is the DD/MM/YYYY string. */
export function DateInput({ value, onChange, placeholder = "DD/MM/YYYY", testid, disabled }) {
  const [open, setOpen] = useState(false);
  const selected = parseUkDate(value);
  return (
    <div className="flex items-center gap-1.5">
      <Input value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} mono data-testid={testid} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" disabled={disabled} aria-label="Pick a date" data-testid={testid ? `${testid}-calendar` : undefined}
            className="h-9 w-9 flex-shrink-0 inline-flex items-center justify-center rounded-md border border-line bg-surface text-ink-3 hover:text-ink hover:border-accent disabled:opacity-50">
            <CalendarDays size={14} />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-auto p-0 z-[80]" onEscapeKeyDown={(e) => e.stopPropagation()}
          data-testid={testid ? `${testid}-calendar-popover` : undefined}>
          <Calendar mode="single" selected={selected || undefined} defaultMonth={selected || undefined}
            onSelect={(d) => { onChange(formatUkDate(d)); setOpen(false); }} />
        </PopoverContent>
      </Popover>
    </div>
  );
}
